import { useQuery } from '@apollo/client';
import { CITRIN_GET_PRICINGS_TAXI, GetPricingsTaxiRequest, GetPricingsTaxiResponse } from '..';
import { PricingTaxiQueryFilterMGT } from '../../shared/types';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';

export const useGetPricingsTaxiQuery = (request: PricingTaxiQueryFilterMGT, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: PricingTaxiQueryFilterMGT) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetPricingsTaxiResponse, GetPricingsTaxiRequest>(
        CITRIN_GET_PRICINGS_TAXI,
        {
            variables: { request: internalRequest },
            // fetchPolicy: 'cache-and-network',
            // onCompleted: (data) => console.log('[MGT] Pricing', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getPricingsTaxi,
        data: data?.CITRIN_MGT_getPricingsTaxi ?? [],
    };
};
